import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  textTitle: {
    fontSize: '12px',
    marginBottom: '5px',
    fontFamily: 'Poppins',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#A2A5A8',
  },
  itemInfo: {
    margin: '19px 0',
    maxHeight: 45,
  },
  detailsText: {
    fontFamily: 'Poppins',
    fontSize: '12px',
  },
  buttonModal: {
    textAlign: 'flex-start',
  },
}));
